import { AxiosResponse, isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

export interface EFacturaFormState {
  type: string | null;
  plateNumber: string;
  container: string;
}

export const generateEir = async (
  eir: EFacturaFormState
): Promise<AxiosResponse> => {
  try {
    const res = await apiClient.post<AxiosResponse>(Endpoints.Eir, {
      ...eir,
    });
    return res;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error?.response?.data[0].errorMessage);
    }
    throw error;
  }
};
